module.exports = __webpack_public_path__ + "static/media/carT5.9e59bae0.jpg";